<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
         <h2>Schedule of Activities</h2>
        </div>
        <div class="closebutton mt-1" >
        <span class="tooltip-wrapper pointer" style="float:right">
            <i class="cursor-pointer fa fa-times" @click.prevent="closePage()"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
        </span>
        </div>
  </div>
    <VisitActivityTree
        :visitData="visitData"
        :version="version"
        :optionsshow=true
    />
</template>
<script src="./VisitInfo.js"/>